import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function ProductCategories() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data.products || [])).catch(() => {});
  }, []);

  return (
    <section id="products" className="bg-[#f9f8f5] py-20 md:py-28" data-testid="products-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="eyebrow text-[#d46a1d]">Our Range</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">
            Seven categories, crafted with precision
          </h2>
          <p className="mt-4 text-lg text-[#55534e]">
            From classical churna to modern cold-pressed juices — every product is manufactured in-house and third-party tested for purity.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p, i) => (
            <motion.a key={p.id} href="#franchise"
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group overflow-hidden rounded-2xl border border-[#e7e0d6] bg-white card-shadow transition-shadow hover:card-shadow-lg"
              data-testid={`product-card-${p.id}`}>
              <div className="aspect-[16/11] overflow-hidden bg-[#f2ece4]">
                <img src={p.image} alt={p.name} loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-serif text-2xl text-[#202124]">{p.name}</h3>
                  <ArrowUpRight size={20} className="text-[#c7bca9] transition-colors group-hover:text-[#d46a1d]" />
                </div>
                <div className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#1f5d3a]">{p.tagline}</div>
                <p className="mt-3 text-sm leading-relaxed text-[#6b6a65]">{p.description}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
